export { StoreHoursInfoDetails } from './StoreHoursInfoDetails';
